var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"#212121","d":"M11,7V0.6L0.6,11L11,21.4V15c6.3,0.1,8.7,1.4,11.1,5.5l1.9,3.2V20C24,9.1,15.6,7.2,11,7z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }